import { createGlobalStyle, keyframes } from 'styled-components';
import { theme, toRem } from 'design';

const toast = keyframes({
  '0%': {
    transform: 'scaleX(1)',
  },
  '100%': {
    transform: 'scaleX(0)',
  },
});

const ToastStyles = createGlobalStyle`
  .Toastify {
    position: fixed;
    top: ${toRem(theme.layout.gutter.small)};
    right: 0;
    left: 0;
    z-index: ${theme.zIndex.toast};
    justify-content: center;
    pointer-events: none;
  }

  .Toastify__toast-container {
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 0 ${toRem(theme.layout.gutter.small)};
    pointer-events: all;

    @media (min-width: ${theme.breakpoint.small}px) {
      width: auto;
    }

    &--top-right {
      position: fixed;
      top: ${toRem(22)}!important;
      right: ${toRem(22)}!important;
      left: ${toRem(22)}!important;
      z-index: ${theme.zIndex.toast};
      flex-flow: column nowrap;
      padding: 0!important;
      overflow: visible!important;

      @media (min-width: ${theme.breakpoint.small}px) {
        top: ${toRem(110)}!important;
        right: ${toRem(theme.layout.gutter.large)}!important;
        left: auto!important;
      }
    }

    &--top-center {
      top: ${toRem(22)}!important;
    }
  }

  .Toastify__toast {
    justify-content: center;
    width: 100%;
    cursor: pointer;

    @media (min-width: ${theme.breakpoint.small}px) {
      width: auto;
    }
  }

  // this is a necessary to make the toasts go away after N seconds
  .Toastify__progress-bar {
    animation: ${toast} linear 1;
  }

  .Toastify__toast-body {
    width: 100%;
    margin-bottom: ${toRem(11)}!important;

    @media (min-width: ${theme.breakpoint.small}px) {
      width: auto;
    }
  }

  .Toastify__close-button {
    display: none;
  }
`;

export default ToastStyles;
